exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Authentication-module__error-wrapper___1vd8P{max-width:940px;margin:0 auto;padding:20px}", ""]);

// exports
exports.locals = {
	"error-wrapper": "Authentication-module__error-wrapper___1vd8P"
};